import { observable } from "@chorda/core";
import createRouter from "router5";
import browserPlugin from 'router5-plugin-browser';
export const useRouter = (scope, setup) => {
    const state = observable({});
    const router = createRouter();
    router.usePlugin(browserPlugin({
        useHash: true
    }));
    router.subscribe((next) => {
        state.$value = next;
        //        console.log(next)
    });
    setup === null || setup === void 0 ? void 0 : setup(router);
    scope.router = state;
    router.start();
};
